const footerHelpTitle = document.querySelector('.footer-help-title')
const footerHelpMenu = document.querySelector('.footer-help-links')
const footerHelpContainer = document.querySelector('.footer-help-container')

footerHelpContainer.addEventListener('click', function() {
    if (footerHelpMenu.getAttribute('style') === 'display: none;') {
        footerHelpMenu.setAttribute('style', 'display: block;')
        footerHelpContainer.querySelector('svg').setAttribute('style', 'transform: rotate(180deg);')
    } else {
        footerHelpMenu.setAttribute('style', 'display: none;')
        footerHelpContainer.querySelector('svg').removeAttribute('style')
    }
})

const footerAboutTitle = document.querySelector('.footer-about-title')
const footerAboutMenu = document.querySelector('.footer-about-links')
const footerAboutContainer = document.querySelector('.footer-about-container')

footerAboutContainer.addEventListener('click', function() {
    if (footerAboutMenu.getAttribute('style') === 'display: none;') {
        footerAboutMenu.setAttribute('style', 'display: block;')
        footerAboutContainer.querySelector('svg').setAttribute('style', 'transform: rotate(180deg);')
    } else {
        footerAboutMenu.setAttribute('style', 'display: none;')
        footerAboutContainer.querySelector('svg').removeAttribute('style')
    }
})

const footerInfoTitle = document.querySelector('.footer-information-title')
const footerInfoMenu = document.querySelector('.footer-information-links')
const footerInfoContainer = document.querySelector('.footer-information-container')

footerInfoContainer.addEventListener('click', function() {
    if (footerInfoMenu.getAttribute('style') === 'display: none;') {
        footerInfoMenu.setAttribute('style', 'display: block;')
        footerInfoContainer.querySelector('svg').setAttribute('style', 'transform: rotate(180deg);')
    } else {
        footerInfoMenu.setAttribute('style', 'display: none;')
        footerInfoContainer.querySelector('svg').removeAttribute('style')
    }
})